// Nomes de processo/etapa (process.description_process, process_step.description_step) são
// texto livre cadastrado pelo usuário nas telas de Processos/Etapas — não passam pelo i18n
// porque não são strings fixas da interface, são dado de banco. Esse dicionário traduz os
// valores conhecidos quando o idioma ativo é inglês; valores não mapeados (etapa nova,
// digitação diferente) simplesmente continuam em português em vez de quebrar.
const DB_LABEL_TRANSLATIONS_EN = {
  // Processos
  "compra": "Purchase",
  "compra normal": "Normal Purchase",
  "transferência": "Transfer",
  "transferencia": "Transfer",
  "teste": "Test",

  // Etapas
  "documento criado": "Document Created",
  "validar assinatura": "Validate Signature",
  "atribuição documento de compras": "Purchase Document Assignment",
  "atribuicao documento de compras": "Purchase Document Assignment",
  "simulação de lançamento": "Posting Simulation",
  "simulacao de lancamento": "Posting Simulation",
  "criar remessa": "Create Delivery",
  "entrada de mercadoria": "Goods Receipt",
  "entrada da danfe": "DANFE Entry",
  "entrada danfe": "DANFE Entry",
  "entrar danfe": "DANFE Entry",
  "entrada de fatura": "Invoice Entry",
  "processo finalizado": "Process Finished",
  "busca pedido": "Search Order",
  "busca lote": "Search Batch",
  "criar recebimento": "Create Goods Receipt",
  "entrar quantidade": "Enter Quantity",
  "entrar depósito": "Enter Warehouse",
  "entrar deposito": "Enter Warehouse",
  "transferência de mercadoria": "Goods Transfer",
  "transferencia de mercadoria": "Goods Transfer",
};

// isEnglish: booleano (ex.: i18n.language?.startsWith("en")) — mantém a assinatura simples
// pra não acoplar esse util a react-i18next.
export function translateDbLabel(text, isEnglish) {
  if (!isEnglish || !text) return text;
  const key = String(text).trim().toLowerCase();
  return DB_LABEL_TRANSLATIONS_EN[key] ?? text;
}
